<template>
  <div class="cropper-container">
    <div class="nav-topbar">
      <div class="mobiles-nav-list">
        <a class="nav-backs" @click="backs()"> 首页 </a>
        <a class="nav-items" @click="NavToStore()">商城 </a>
      </div>
      <div class="nav-list">
        <a class="nav-backs" @click="backs()"> 首页 </a>
        <a class="nav-items" @click="NavToStore()">商城 </a>
      </div>
    </div>
    <div>
      <el-upload class="upload-demo" name="file" action="https://sosunlive.com/api/common/uploads"
        :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileLists" :on-success="handleSuccesss"
        list-type="picture" :before-upload="beforeUpload" :limit="1" accept=".gif,.jpg,.png">
        <el-button size="small" type="warning">点击上传DIY图片</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，且不超过5MB
        </div>
      </el-upload>
    </div>
    <vue-cropper ref="cropper" :img="option.img" :outputSize="option.outputSize" :outputType="option.outputType"
      :info="option.info" :canScale="option.canScale" :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth"
      :autoCropHeight="option.autoCropHeight" :fixed="option.fixed" :fixedNumber="option.fixedNumber"
      @realTime="realTime" @imgLoad="imgLoad" style="width: 100%; height: 430px;"></vue-cropper>

    <div class="btn-group" v-if="custom_params.count > 1">
      <div style="line-height: 28px;text-align: left;width: 98%;overflow: hidden;margin: 0px auto;">可重叠使用图片DIY</div>
      <el-input type="text" size="small" v-model="num" style="width:98%;margin: 0px auto;" clearable
        placeholder="请输入重叠张数"></el-input>
    </div>
    <div class="btn-group">
      <!--
        <button @click="startCrop">开始裁剪</button>
        <button @click="stopCrop">停止裁剪</button>
        <button @click="clearCrop">清除裁剪</button>-->
      <button @click="changeScale(1)">放大</button>
      <button @click="changeScale(-1)">缩小</button>
      <button @click="rotateLeft">左旋转</button>
      <button @click="rotateRight">右旋转</button>
      <button @click="getCropData">生成并保存</button>
    </div>
    <div class="preview-box">
      <!--
      <div class="preview" :style="previews.div">
        <img :src="previews.url" :style="previews.img">
      </div>
      -->
      <div class="preview" :style="previews.div" v-if="num == 1">
        <img :src="previews.url" :style="previews.img">
      </div>
      <!--
      <div v-if="num > 1">
        <img v-for="(val, index) in List" :src="val" style="width: 33%;float: left;height: auto;"></img>
      </div>-->
    </div>

  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
export default {
  name: 'CropperDemo',
  components: {
    VueCropper
  },
  data() {
    return {
      custom_params: {
        count: 1
      },
      fileLists: [

      ],
      baseURL: 'https://sosunlive.com',
      id: 31,//this.$route.params.id,//31
      Imgurl: '',
      detailInfo: '',
      List: [],
      num: 1,
      option: {
        img: '',
        outputSize: 1,
        outputType: 'png',
        info: true,
        canScale: true,
        //autoCrop: true,
        autoCrop: true,
        autoCropWidth: 400,
        autoCropHeight: 400,
        //fixed: true,
        fixed: false,
        fixedNumber: [],
        //fixedNumber: [3, 3]
      },
      previews: {

      }
    }
  },
  mounted() {
    let self = this
    self.init()
  },
  methods: {
    backs() {
      let self = this
      self.$router.push("/index");
    },
    NavToStore() {
      let self = this
      self.$router.push("/store");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeUpload(file) {
      let isRightSize = file.size / (1024 * 500) < 5;
      if (!isRightSize) {
        this.$message.error(`文件大小超过5MB`);
        return false;
      }
    },
    handleSuccesss(res, file, fileList) {
      if (res.code == 1) {
        this.option.img = this.baseURL + res.data.url
        localStorage.setItem("diyImage", res.data.url)
        this.fileLists.push({
          name: res.data.url,
          fileId: res.data.url,
          url: res.data.url,
        });
        this.$emit("input", this.fileLists);
      } else {
        fileList.filter((o) => o.uid != file.uid);
        this.$emit("input", this.fileLists);
        this.$message({ message: res.msg, type: "error", duration: 1500 });
      }
    },
    init() {
      let id = this.id;
      id = 31
      let self = this
      this.$api.mall.getGoodDetail(id).then((res) => {
        self.custom_params = JSON.parse(res.data.wap_custom_params)
        if (self.custom_params) {
          self.option.autoCropWidth = self.custom_params.w
          self.option.autoCropHeight = self.custom_params.h
          self.option.fixedNumber = [self.custom_params.bili]
        }
        self.detailInfo = res.data
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      });
    },
    // 实时预览
    realTime(data) {
      this.previews = data
    },

    // 图片加载完成
    imgLoad(msg) {
      console.log('图片加载:', msg)
    },

    // 开始裁剪
    startCrop() {
      this.$refs.cropper.startCrop()
    },

    // 停止裁剪
    stopCrop() {
      this.$refs.cropper.stopCrop()
    },

    // 清除裁剪
    clearCrop() {
      this.$refs.cropper.clearCrop()
    },

    // 缩放
    changeScale(num) {
      this.$refs.cropper.changeScale(num)
    },

    // 左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },

    // 右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },

    // 获取裁剪结果
    getCropData() {
      let self = this
      /**
      self.$refs.cropper.getCropData((data) => {
        self.$api.mall.setBase64({ base64: data }).then((res) => {
          if (res.code == 1) {
            self.Imgurl = res.data.url
            localStorage.setItem("Imgurl",self.Imgurl)
            self.$router.push("/GoodDetail/"+self.id);
          } else {
            self.$layer.msg(res.data.msg)
          }
        });
      })**/
      // 获取blob数据
      /**
      this.$refs.cropper.getCropBlob((data) => {
        console.log('Blob结果:', data)
      })**/
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 8000px) and (min-width: 1024px) {
  .cropper-container {
    max-width: 800px;
    margin: 0px auto;
    padding: 46px 0px 0px 0px;

    .nav-topbar {
      width: 100%;
      overflow: hidden;
      background: #ffe url('/imgs/fade.png') top center repeat-x;
      position: fixed;
      top: 0px;
      left: 0px;
      z-index: 10;

      .mobiles-nav-list {
        display: none;
      }

      .nav-list {
        width: 980px;
        overflow: hidden;
        margin: 0px auto;

        .searchTexts {
          width: 50%;
          float: right;
          overflow: hidden;
          margin: 6px auto;
        }

        .nav-backs {
          text-decoration: none;
          display: block;
          font-weight: 400;
          overflow: hidden;
          color: maroon;
          line-height: 45px;
          text-align: center;
          float: left;
          cursor: pointer;
        }

        .nav-items {
          text-decoration: none;
          display: block;
          margin-left: 12px;
          font-weight: 400;
          overflow: hidden;
          color: maroon;
          line-height: 45px;
          text-align: center;
          float: left;
        }

        .nav-backs:hover {
          color: red !important;
          text-decoration: underline;
        }
      }
    }
  }

  .btn-group {
    margin: 20px 0;
    text-align: center;
  }

  .btn-group button {
    margin: 0 5px;
    padding: 8px 16px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .btn-group button:hover {
    background: #0056b3;
  }

  .preview-box {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .preview {
    width: 200px;
    height: 133px;
    overflow: hidden;
    border: 1px solid #ccc;
    margin: 0 auto;
    /**border-radius: 50%;
    filter: grayscale(100%);**/
  }
}

@media (max-width: 1024px) and (min-width: 320px) {
  .cropper-container {
    max-width: 800px;
    margin: 46px auto;

    .nav-topbar {
      width: 100%;
      overflow: hidden;
      position: fixed;
      top: 0px;
      left: 0px;
      z-index: 10;
      background: url('/imgs/fade.png') top center repeat-x;

      .mobiles-nav-list {
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0px;
        margin: 0px auto;

        .nav-backs {
          text-decoration: none;
          display: block;
          margin-left: 12px;
          font-weight: 400;
          overflow: hidden;
          color: maroon;
          line-height: 45px;
          text-align: center;
          float: left;
        }

        .nav-items {
          text-decoration: none;
          display: block;
          margin-left: 12px;
          font-weight: 400;
          overflow: hidden;
          color: maroon;
          line-height: 45px;
          text-align: center;
          float: left;
        }
      }

      .nav-list {
        display: none;
      }
    }
  }

  .btn-group {
    margin: 20px 0;
    text-align: center;
  }

  .btn-group button {
    margin: 0 5px;
    padding: 8px 16px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .btn-group button:hover {
    background: #0056b3;
  }

  .preview-box {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .preview {
    width: 200px;
    height: 133px;
    overflow: hidden;
    border: 1px solid #ccc;
    margin: 0 auto;
    /**  border-radius: 50%;
    filter: grayscale(100%);**/
  }

}
</style>